import errorsController  from '@/utils/errorsController';
import { customInstanceAWS } from '@/http';
import { ZodGetTotalDocuments, GetTotalDocuments, ZodGetTotalDocumentsOps, GetTotalDocumentsOps } from '@/types';
import { AppwriteException } from 'appwrite';
import { AxiosError } from 'axios';

export async function getTotalDocuments(params?: GetTotalDocuments, ops?: GetTotalDocumentsOps) {
  try {
		ZodGetTotalDocuments.parse(params)
		const zData = ZodGetTotalDocumentsOps.parse(ops)
		const args: {is_demo?: string | undefined} = {}

		if (zData && zData.is_demo !== undefined) {
			args.is_demo = zData.is_demo.toString()
		}

    const { data } = await customInstanceAWS.get(`/${params}/items/count?${new URLSearchParams(args).toString()}`);

    return data;
  } catch (error: AppwriteException | AxiosError | Error | unknown) {
    if (error instanceof AppwriteException || error instanceof AxiosError || error instanceof Error) {
      return errorsController(error, false);
    }
  }
}
